import { SvgIconType } from './svg.interface';

const Note: SvgIconType = ({
  width = 12,
  height = 12,
  className = '',
  color = '#8792A2'
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 12H6.75V8.25C6.75 7.42157 7.42157 6.75 8.25 6.75H12V1.5C12 0.671573 11.3284 0 10.5 0H1.5C0.671573 0 0 0.671573 0 1.5V10.5C0 11.3284 0.671573 12 1.5 12ZM8.25 8.25V12L12 8.25H8.25Z"
      fill={color}
    />
  </svg>
);

export default Note;
